import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import posed from "react-pose";

export const Base = styled.div<{ stretch?: boolean }>`
  width: ${p => (p.stretch ? "100%" : null)};
`;

/**
 * Ik zou de styled component zo dom mogelijk maken. Dwz, wat betekend level
 * voor ItemBase? Beste is om bij dingen als 'domme' components details van
 * implementatie, in dit geval level, weg te houden. Denk bijv meer aan wat het
 * gewenste effect is. bijv 'showBorderBottomOnLastChild'
 */

type ItemBaseProps = {
  showBorderBottomOnLastChild: boolean;
};

export const ItemBase = styled.div<ItemBaseProps>`
  border-top: 1px solid ${select.color(["grey", 1])};

  ${p =>
    p.showBorderBottomOnLastChild &&
    css`
      &:last-child {
        border-bottom: 1px solid ${select.color(["grey", 1])};
      }
    `}
`;

type ItemInnerProps = {
  indentation: number;
};

// Zie comment bij ItemBase: identation
export const ItemInner = styled.div<ItemInnerProps>`
  display: flex;
  align-items: center;
  position: relative;
  padding: ${select.space(3)} ${select.space(2)};
  padding-left: ${p => `${p.indentation}px`};
  transition: ${select.speed("fast")};
  &:hover {
    background-color: ${select.color(["grey", 0])};
  }
`;

export const ItemMain = styled.div`
  flex-grow: 1;
  padding-left: ${select.space(4)};
  position: relative;
`;

type PlusToMinIconProps = {
  value: boolean;
};

const PlusToMinIconBase = styled.div<PlusToMinIconProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: -5px;
  top: -2px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: 0.2s ease;
  transform: ${p => (!p.value ? "rotate(0)" : "rotate(90deg)")};

  &:before,
  &:after {
    display: block;
    width: 10px;
    height: 2px;
    background-color: ${select.color(["grey", 7])};
    position: absolute;
    left: 5px;
    top: 9px;
    content: "";
  }

  &:before {
    transition: 0.2s ease;
    transform: ${p => (!p.value ? "scaleX(1)" : "scaleX(0)")};
  }

  &:after {
    transform: rotate(90deg);
  }
`;

export const PlusToMinIcon = ({ value }: PlusToMinIconProps) => {
  return <PlusToMinIconBase value={value} />;
};

export const ItemsOuter = styled(
  posed.div({
    enter: {
      height: "auto",
      transition: {
        stiffness: 200,
        damping: 15
      }
    },
    exit: {
      height: 0,
      transition: {
        stiffness: 300,
        damping: 20
      }
    }
  })
)`
  position: relative;
  overflow: hidden;
`;
